var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { padding: 0 }, attrs: { "max-width": "1000" } },
    [
      _c("w-card-title", [
        _vm._v(
          _vm._s(_vm.$ct("open-documentens-for", { name: _vm.contactName }))
        ),
      ]),
      _vm.showProgress
        ? _c("w-progress-linear", {
            staticClass: "full",
            attrs: { value: _vm.downloadProgress },
          })
        : _vm._e(),
      _c(
        "app-reminder-send-modal-card",
        { attrs: { contact: _vm.contact } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "", "no-padding": "" } },
            [
              _c(
                "w-col",
                { staticClass: "white", attrs: { md: "8", xs: "12" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-textarea", {
                            ref: "textarea",
                            style: { width: "100%", minHeight: "400px;" },
                            attrs: {
                              label: _vm.$ct("text"),
                              value: _vm.templateText,
                              fancy: "",
                              height: "250",
                              disabled: _vm.inputsDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.$emit("update:templateText", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                {
                  staticClass: "blue-back",
                  attrs: { block: "", md: "4", xs: "12" },
                },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.templateItems,
                              label: _vm.$ct("reminder"),
                              value: _vm.selectedTemplate,
                              fancy: "",
                              disabled: _vm.inputsDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.$emit(
                                  "update:selectedTemplate",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.addressItems,
                              label: _vm.$ct("address"),
                              value: _vm.selectedAddress,
                              fancy: "",
                              disabled: _vm.inputsDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.$emit(
                                  "update:selectedAddress",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.emailTemplateItems,
                              label: _vm.$ct("email-template"),
                              value: _vm.selectedEmailTemplate,
                              fancy: "",
                              disabled: _vm.inputsDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.$emit(
                                  "update:selectedEmailTemplate",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.layoutItems,
                              label: _vm.$ct("reminder-layout"),
                              value: _vm.selectedLayout,
                              fancy: "",
                              disabled: _vm.inputsDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.$emit(
                                  "update:selectedLayout",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "mr",
              attrs: { disabled: _vm.inputsDisabled },
              on: {
                click: function ($event) {
                  return _vm.printDocument()
                },
              },
            },
            [
              _c("span", { staticClass: "icon icon-printer mrs" }),
              _vm._v(_vm._s(_vm.$t("common.print")) + " "),
            ]
          ),
          _c(
            "w-button",
            {
              staticClass: "mr",
              attrs: { disabled: _vm.inputsDisabled },
              on: {
                click: function ($event) {
                  return _vm.downloadDocument()
                },
              },
            },
            [
              _c("span", { staticClass: "icon icon-download mrs" }),
              _vm._v(_vm._s(_vm.$t("common.download")) + " "),
            ]
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.inputsDisabled },
              on: {
                click: function ($event) {
                  return _vm.$emit("next")
                },
              },
            },
            [
              _c("span", { staticClass: "icon icon-envelope mrs" }),
              _vm._v(_vm._s(_vm.$t("common.send")) + " "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }